// Theme tokens supplied by the native app via ui.get {type:'themeColors'}.
export type ThemeToken =
  | 'primaryColor'
  | 'primaryDarkColor'
  | 'primaryLightColor'
  | 'accentColor';

// Sparse: only the tokens the app actually sent. Each is a '#'-prefixed hex.
export type ThemeTokens = Partial<Record<ThemeToken, string>>;

const THEME_TOKEN_KEYS: ThemeToken[] = [
  'primaryColor',
  'primaryDarkColor',
  'primaryLightColor',
  'accentColor',
];

// Normalize a raw ui.get result into a sparse token map.
// Mirrors the app-side parse recipe: string-or-object -> optional single-level
// `.data` unwrap -> read the four keys. Only truthy values are kept; missing/empty
// tokens are dropped so the call site falls back to its current hex.
export const resolveThemeTokens = (res: unknown): ThemeTokens => {
  if (res == null) return {};

  let data: any = res;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return {};
    }
  }
  if (data && typeof data === 'object' && data.data) {
    data = data.data;
  }
  if (!data || typeof data !== 'object') return {};

  const out: ThemeTokens = {};
  THEME_TOKEN_KEYS.forEach((key) => {
    if (data[key]) {
      out[key] = data[key];
    }
  });
  return out;
};
